'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GenericMethods = function GenericMethods($http) {
    _classCallCheck(this, GenericMethods);

    return {
        retrieveLocalFile: function retrieveLocalFile(directory, fileName) {
            var browserRootDir = '/../../assets/';
            // Example: /../../assets/data/advindaCountryList.json
            return $http.get(browserRootDir + directory + fileName);
        }
    };
};

exports.default = GenericMethods;


/** WEBPACK FOOTER **
 ** ./src/app/services/genericMethods.js
 **/